import { ApiPost } from '../util/axios'
import { consoleLog } from '../util'

const getAdminDetailedActivityCountApi = async data => {
  const options = {
    reqId: 'GetAdminDetailedActivityCount',
    payload: data,
    resId: 'GetAdminDetailedActivityCountResult',
    resType: 'object'
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getProjectActivityCountApi = async data => {
  const options = {
    reqId: 'GetProjectActivityCount',
    payload: data,
    resId: 'GetProjectActivityCountResult',
    resType: 'object'
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getAdminActivityCountApi = async data => {
  const options = {
    reqId: 'GetAdminActivityCount',
    payload: data,
    resId: 'GetAdminActivityCountResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getAdminUserLogApi = async data => {
  const options = {
    reqId: 'GetAdminUserLog',
    payload: data,
    resId: 'GetAdminUserLogResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

export default {
  getAdminDetailedActivityCountApi,
  getProjectActivityCountApi,
  getAdminActivityCountApi,
  getAdminUserLogApi
}
